module.exports = __webpack_public_path__ + "img/chat.9e6d9d42.svg";